module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Ad-UC_1.56ae4b82.jpg";